import React from 'react';
import './tagModal.css';
import Dialog from '../ui/dialog';

const TagModal = ({ tag, isEditing, onClose, onEdit, onDelete, onSave, onInputChange, onColorChange }) => {
  if (!tag) return null;

  return (
    <Dialog open={tag} onClose={onClose} hideCancel hideConfirm>
      <div className="modal-content">
        <h2>{isEditing ? "Edit Tag" : "Tag Details"}</h2>
        <div className="tag-details">
          <div>
            <label>Tag:</label>
            {isEditing ? (
              <input
                type="text"
                name="tag"
                value={tag.tag}
                onChange={onInputChange}
              />
            ) : (
              <p>{tag.tag}</p>
            )}
          </div>
          <div>
            <label>Colour:</label>
            {isEditing ? (
              <input
                type="color"
                name="colour"
                value={tag.colour}
                onChange={onColorChange}
              />
            ) : (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    width: 20,
                    height: 20,
                    backgroundColor: tag.colour,
                    marginRight: 8,
                    border: '1px solid #ccc'
                  }}
                ></div>
                <p>{tag.colour}</p>
              </div>
            )}
          </div>
        </div>

        <div className="modal-buttons">
          {isEditing ? (
            <button onClick={onSave}>Save</button>
          ) : (
            <button onClick={onEdit}>Edit</button>
          )}
          <button onClick={onDelete}>Delete</button>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </Dialog>
  );
};

export default TagModal;
